import React, { useState, useEffect, useRef } from "react";
import { MdKeyboard } from "react-icons/md";
import axios from 'axios';
import useAuth from '../../Users/hooks/useAuth';
import { getLanguageFlag } from "./flags";

import { BsArrowsCollapse, BsArrowsExpand } from "react-icons/bs";




// Import UI Components
import { KeyboardHelpModal } from './components/KeyboardHelpModal';

import { MobileHeader } from './components/MobileHeader';

import ProgressPill from './ProgressPill';

import ProgressModal from "./ProgressModal";

import ExerciseHelpModal from './ExerciseHelpModal';
import ContextHelpModal from "./ContextHelpModal";
import ChapterCommentsPanel from "./SnapsWise/comments/ChapterCommentsPanel";
import { loadCourse } from './guidelines/loadCourse';



import WordActionMenu from "./SnapsWise/WordActionMenu";
import PresentationModeView from "./SnapsWise/PresentationModeView";
import PracticeModeView from "./SnapsWise/PracticeModeView";
import PresentationModeToggle from "./SnapsWise/PresentationModeToggle";



// Custom hook for mobile detection
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(window.innerWidth < 1280);
        };
        
        checkDevice();
        window.addEventListener('resize', checkDevice);
        
        return () => {
            window.removeEventListener('resize', checkDevice);
        };
    }, []);

    return isMobile;
};

// Shadowing timing configuration



const SHADOWING_TIMING = {
  CUE_TOTAL_DURATION: 2200,
  PULSE_1_TIME: 200,
  PULSE_2_TIME: 800,
  PULSE_3_TIME: 1600,
  CUE_CLEAR_TIME: 600,
  RECORDING_START_OFFSET: -100,
  AUDIO_START_DELAY: 2200,
  POST_AUDIO_BUFFER: 200,
};

// Echoing timing configuration - SHORTER like shadowing
const ECHOING_TIMING = {
  PULSE_1_TIME: 200,
  PULSE_2_TIME: 500,
  PULSE_3_TIME: 900,
  CUE_CLEAR_TIME: 200,
  TOTAL_DURATION: 1100,
};

const SnapsWise = ({subject, file, sectionTitle})=>{
   
    const [showIntonationHelp, setShowIntonationHelp] = useState(false);

    // ============================================
    // SECTION 1: STATE MANAGEMENT
    // ============================================
    const [protectedAssessmentAudioUrl, setProtectedAssessmentAudioUrl] = useState(null);
    const [protectedNarratorAudioUrl, setProtectedNarratorAudioUrl] = useState(null);
    const [modelSize, setModelSize] = useState("turbo");
    const [rate, setRate] = useState(1);
    const [loading, setLoading] = useState(false);
    const [segment, setSegment] = useState({});
    const [isgranted, setIsGranted] = useState(false);
    const [stream, setStream] = useState();
    const [audio, setAudio] = useState(null);
    const [hasRecording, setHasRecording] = useState(false);
    const [assessment, setAssessment] = useState(null);
    const { auth, setAuth } = useAuth();
    const token = localStorage.getItem("token");
    const isGuest = auth?.username === "guest";
    const isPublic = !token || isGuest;
    const canUsePronunciationApi = !!token && !isGuest;
  
    const [segments, setSegments] = useState();
    const [broadcastTime, setBroadcastTime] = useState(0);
    
  
    const [focus, setFocus] = useState({});
    const [focused, setEdFocus] = useState();
    
  
    const [translation, setTranslation] = useState();
    
    // State for visualization and layout
    const [showIntonationVisualization, setShowIntonationVisualization] = useState(true);
    const [viewMode, setViewMode] = useState("practice");
    const [visualizationView, setVisualizationView] = useState('pitch');
    const [activeTab, setActiveTab] = useState('sentence');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showKeyboardHelp, setShowKeyboardHelp] = useState(false);
    

    const [showComments, setShowComments] = useState(false);
    const [commentCounts, setCommentCounts] = useState({
        segment: 0,
        chapter: 0,
        });
    // New state for translation modal
    const [showTranslationModal, setShowTranslationModal] = useState(false);
    
    // Practice mode states
    const [practiceMode, setPracticeMode] = useState('echoing');
    const [preservedMode, setPreservedMode] = useState('echoing');
    
    // Echoing mode states
    const [echoingPhase, setEchoingPhase] = useState('idle');
    const [echoingTimeout, setEchoingTimeout] = useState(null);
    const [echoingPulseCount, setEchoingPulseCount] = useState(0);
    const [echoingTimeouts, setEchoingTimeouts] = useState([]);
    const echoingPhaseRef = useRef('idle');

    //word lane
    const wordPlayRafRef = useRef(null);
    const wordPlayEndRef = useRef(null);


 const getRecorderMimeType = () => {
  if (typeof MediaRecorder === "undefined") return "";

  const ua = navigator.userAgent || "";
  const isFirefox = ua.includes("Firefox/");
  const isOpera = ua.includes("OPR/") || ua.includes("Opera");

  const candidates = isFirefox
    ? [
        "audio/ogg;codecs=opus",
        "audio/webm;codecs=opus",
        "audio/ogg",
        "audio/webm",
      ]
    : isOpera
    ? [
        "audio/webm;codecs=opus",
        "audio/webm",
        "audio/mp4",
      ]
    : [
        "audio/webm;codecs=opus",
        "audio/webm",
        "audio/mp4",
        "audio/ogg;codecs=opus",
      ];

  for (const type of candidates) {
    try {
      if (MediaRecorder.isTypeSupported?.(type)) return type;
    } catch (e) {}
  }

  return "";
};
const getRecorderOptions = () => {
  const pickedMimeType = getRecorderMimeType();
  return pickedMimeType ? { mimeType: pickedMimeType } : undefined;
};

const createRecorder = (mediaStream) => {
  if (!(mediaStream instanceof MediaStream)) {
    throw new Error("createRecorder expected a MediaStream");
  }

  const options = getRecorderOptions();
  return options
    ? new MediaRecorder(mediaStream, options)
    : new MediaRecorder(mediaStream);
};


    const stopWordPlayRAF = () => {
  if (wordPlayRafRef.current) {
    cancelAnimationFrame(wordPlayRafRef.current);
    wordPlayRafRef.current = null;
  }
  wordPlayEndRef.current = null;
};

const playRangePrecise = (absStart, absEnd) => {
  const a = audioref.current;
  if (!a) return;

  stopWordPlayRAF();     // stop any previous word playback loop

  // Ensure valid range
  const start = Math.max(0, absStart);
  const end = Math.max(start, absEnd);

  wordPlayEndRef.current = end;

  a.currentTime = start;
  a.play();

  const tick = () => {
    const aa = audioref.current;
    const targetEnd = wordPlayEndRef.current;

    if (!aa || targetEnd == null) return;

    // Stop precisely
    if (aa.currentTime >= targetEnd) {
      aa.pause();
      stopWordPlayRAF();
      setIsPlayingSegment(false);
      return;
    }

    wordPlayRafRef.current = requestAnimationFrame(tick);
  };

  wordPlayRafRef.current = requestAnimationFrame(tick);
};

const handleLaneWordClick = (wRel) => {
  if (!wRel || segment?.start == null) return;

  cancelAllProcesses();
  setFocus(segment);
  setIsPlayingSegment(true);

  const absStart = segment.start + wRel.start;
  const absEnd = segment.start + wRel.end;

  playRangePrecise(absStart, absEnd);
};
    
    // Shadowing mode states
    const [isShadowing, setIsShadowing] = useState(false);
    const [shadowingTimeout, setShadowingTimeout] = useState(null);
    const [showFirstWordCue, setShowFirstWordCue] = useState(false);
    const [cuePulseCount, setCuePulseCount] = useState(0);
    const [isCueActive, setIsCueActive] = useState(false);
    const [cueTimeouts, setCueTimeouts] = useState([]);
    
    // Recording states
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [audioChunks, setAudioChunks] = useState([]);
    const [duration, setDuration] = useState(6);
    const [isPlayingSegment, setIsPlayingSegment] = useState(false);
    const [currentWord, setCurrentWord] = useState(0);
    const [recordingProgress, setRecordingProgress] = useState(0);
    const [maxRecordingTime, setMaxRecordingTime] = useState(0);

   
    const STEP_SECONDS = 1 * 60;
    const MIN_GOAL_SECONDS = 1 * 60; // change later if you want
    const [todaySeconds, setTodaySeconds] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [goalSeconds, setGoalSeconds] = useState(5 * 60);

    const [wordMenu, setWordMenu] = useState(null);

    const [course, setCourse] = useState(null);
    const [showExerciseHelp, setShowExerciseHelp] = useState(false);

    // --- Help intro (expanded anchor on exercise load) ---
    const [showHelpIntro, setShowHelpIntro] = useState(false);
    const helpIntroTimerRef = useRef(null);
    const lastIntroKeyRef = useRef(null);

    const deriveExerciseId = (subject, file) => {
  const key = subject?.course_key;
  const name = file?.file;
  if (!key || !name) return null;

  // ✅ Flyt og rytme naming scheme ONLY
  if (key === "flyt-og-rytme") {
    // Matches: 01a_nodoubles.mp3, 01A.mp3, 2b-something.mp3
    const m = String(name).match(/^(\d{1,2})\s*([abAB])(?=[._-]|$)/);
    if (!m) return null;
    return `${parseInt(m[1], 10)}${m[2].toUpperCase()}`;
  }

  // ✅ Other courses later:
  // if (key === "other-course") { ... }

  return null;
};


    const openWordMenu = (e, text, i) => {
  e.preventDefault();
  e.stopPropagation();
  const r = e.currentTarget.getBoundingClientRect();
  setWordMenu({ text, i, rect: { left: r.left, top: r.top, width: r.width, height: r.height } });
};

const closeWordMenu = () => setWordMenu(null);

const fetchCommentCounts = async () => {
  if (!subject || !file?.file || !segment?.text) {
    setCommentCounts({ segment: 0, chapter: 0 });
    return;
  }

  try {
    const res = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/comments/counts`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
        body: JSON.stringify({
          subject: {
            author: subject.author,
            title: subject.title,
            language: subject.language,
            type: subject.type,
            owner: subject.owner || null,
          },
          file: file.file,
          anchor: {
            start: segment.start,
            end: segment.end,
            text: segment.text,
          },
        }),
      }
    );

    if (!res.ok) return;

    const json = await res.json();

    setCommentCounts({
      segment: json.segment || 0,
      chapter: json.chapter || 0,
    });
  } catch (e) {
    console.error("fetchCommentCounts failed:", e);
  }
};

const fetchProtectedAudioBlobUrl = async (audioUrl) => {
  const token = localStorage.getItem("token");
  if (!audioUrl || !token) return null;

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_USER_API_URL}${audioUrl}`,
      {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error("Failed to fetch protected audio:", error);
    return null;
  }
};

const resolveBackendAudioUrl = (value) => {
  if (!value) return null;

  // already absolute
  if (typeof value === "string" && value.startsWith("http")) {
    return value;
  }

  // backend relative route like /audio/... or /upload/audio/... or /uploads/...
  if (typeof value === "string" && value.startsWith("/")) {
    return `${process.env.REACT_APP_USER_API_URL}${value}`;
  }

  // old-style relative path fallback
  if (typeof value === "string") {
    return `${process.env.REACT_APP_USER_API_URL}/${value}`;
  }

  return null;
};

    const assessmentAudioUrl = resolveBackendAudioUrl(
  assessment?.audio_url ||
  assessment?.intonation?.audio_url ||
  assessment?.file
);

const narratorAssessmentAudioUrl = resolveBackendAudioUrl(
  assessment?.narrator_intonation?.audio_url ||
  assessment?.narrator_intonation?.file_narrator
);

const isPrivateAudioRoute = (url) =>
  typeof url === "string" && url.includes("/audio/private/");

const resolvedAssessmentAudioUrl = isPrivateAudioRoute(assessmentAudioUrl)
  ? protectedAssessmentAudioUrl || null
  : assessmentAudioUrl || null;

const resolvedNarratorAssessmentAudioUrl = isPrivateAudioRoute(narratorAssessmentAudioUrl)
  ? protectedNarratorAudioUrl || null
  : narratorAssessmentAudioUrl || null;

const authHeaders = () => {
  const t = localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};
const handleAuthExpired = () => {
  // Soft mode: just drop token + fall back to public mode
  localStorage.removeItem("token");

  // Optional: if you want UI to clearly switch to guest styling
  try {
    setAuth((prev) => ({ ...(prev || {}), username: "guest", role: prev?.role }));
  } catch (e) {
    // ignore if setAuth not available in some contexts
  }
};


const renderHelpPill = () => {
  const isIntro = showHelpIntro && introAnchorTitle;

  if (helpEnabled && hasExerciseHelp) {
    return (
      <button
        type="button"
        onClick={() => setShowExerciseHelp(true)}
        className={[
          "group h-9 px-4 rounded-full",
          "bg-gradient-to-r from-blue-50 to-indigo-50",
          "border border-blue-200/60",
          "hover:from-blue-100 hover:to-indigo-100 hover:border-blue-300",
          "transition-all duration-200",
          "flex items-center gap-2",
          "text-sm font-semibold text-blue-700",
          "shadow-sm hover:shadow-md",
          "min-w-0",
        ].join(" ")}
      >
        <span className="w-6 h-6 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs shadow-sm shrink-0">
          🎯
        </span>

        <span className="min-w-0 truncate whitespace-nowrap">
          {isIntro ? introAnchorTitle : `${headerTitle} – ${helpActionLabel}`}
        </span>

        <span className="text-blue-500 group-hover:translate-x-0.5 transition-transform shrink-0">
          ›
        </span>
      </button>
    );
  }

  if (helpEnabled && hasContextHelp) {
    return (
      <button
        type="button"
        onClick={() => setShowExerciseHelp(true)}
        className={[
          "group h-9 px-4 rounded-full",
          "bg-gradient-to-r from-sky-50 to-blue-50",
          "border border-sky-200/60",
          "hover:from-sky-100 hover:to-blue-100 hover:border-sky-300",
          "transition-all duration-200",
          "flex items-center gap-2",
          "text-sm font-semibold text-sky-700",
          "shadow-sm hover:shadow-md",
          "min-w-0",
        ].join(" ")}
      >
        <span className="w-6 h-6 rounded-full bg-sky-500 text-white flex items-center justify-center text-xs shadow-sm shrink-0">
          🗺️
        </span>

        <span className="min-w-0 truncate whitespace-nowrap">
          {`${headerTitle} – ${helpActionLabel}`}
        </span>

        <span className="text-sky-500 group-hover:translate-x-0.5 transition-transform shrink-0">
          ›
        </span>
      </button>
    );
  }

  return (
    <div className="px-5 py-2 rounded-full bg-gradient-to-r from-indigo-50 via-white to-blue-50 border border-indigo-200/70 shadow-[0_10px_30px_-18px_rgba(59,130,246,.55)] text-sm font-extrabold text-slate-900 tracking-tight inline-flex items-center gap-2 backdrop-blur-sm truncate max-w-[70vw]">
      <span className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 text-white flex items-center justify-center shadow-sm text-xs shrink-0">
        🎯
      </span>
      <span className="truncate">{headerTitle}</span>
    </div>
  );
};

const renderCommentsPill = () => {
  if (!subject || !file || !segment?.text) return null;

  const total = commentCounts.segment + commentCounts.chapter;

  return (
    <button
      type="button"
      onClick={() => setShowComments(true)}
      className="group h-9 px-4 rounded-full bg-white/80 hover:bg-white border border-blue-200/70 hover:border-blue-400 shadow-sm hover:shadow-md transition-all duration-200 inline-flex items-center gap-2 text-sm font-bold text-slate-800"
      title="Open comments"
    >
      <span className="w-6 h-6 rounded-full bg-white border border-blue-200 flex items-center justify-center text-xs">
        💬
      </span>

      <span>Comments</span>

      <span className="text-xs text-gray-500">
        {commentCounts.segment}/{commentCounts.chapter}
      </span>

      {total > 0 && (
        <span className="w-2 h-2 rounded-full bg-blue-500" />
      )}
    </button>
  );
};
const fetchDailyGoal = async (language) => {
  if (!language) return;
  try {
    const res = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/goals/daily?language=${encodeURIComponent(language)}`,
      { headers: authHeaders() }
    );

    if (res.status === 401 || res.status === 403) return handleAuthExpired();
    if (!res.ok) return;

    const json = await res.json();
    const n = Number(json.goal_seconds);
    setGoalSeconds(Number.isFinite(n) ? n : MIN_GOAL_SECONDS);
  } catch (e) {
    console.error("fetchDailyGoal error:", e);
  }
};


const clampGoal = (s) => Math.min(6 * 60 * 60, Math.max(MIN_GOAL_SECONDS, s));

const updateDailyGoal = async (nextGoalSeconds) => {
  const language = subject?.language;
  if (!language) return;

  const next = clampGoal(nextGoalSeconds);
  

  try {
    const url =
      `${process.env.REACT_APP_USER_API_URL}/goals/daily` +
      `?language=${encodeURIComponent(language)}` +
      `&goal_seconds=${next}`;
  
    const res = await fetch(url, {
      method: "PUT",
      headers: authHeaders(),
    });
    
    if (!res.ok) {
      console.warn("updateDailyGoal failed:", res.status);
      return;
    }

    const json = await res.json();
   

    const n = Number(json.goal_seconds);
    setGoalSeconds(Number.isFinite(n) ? n : next);
  } catch (e) {
    console.error("updateDailyGoal error:", e);
  }
};



 const fetchTodayActivity = async (language) => {
  if (!language) return;
  if (isGuest) return; // <-- guests: do nothing

  try {
    const res = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/activity/today?language=${encodeURIComponent(language)}`,
      { headers: authHeaders() }  // <-- reuse your helper
    );

    if (res.status === 401 || res.status === 403) return handleAuthExpired();
    if (!res.ok) return;

    const json = await res.json();
    setTodaySeconds(json.done_seconds ?? 0);
  } catch (e) {
    console.error("fetchTodayActivity error:", e);
  }
};


    


    // ============================================
    // SECTION 2: REFS
    // ============================================
    const audioRecordRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const keyboardListenerRef = useRef(null);
    const mediaRecorder = useRef(null);
    const audioref = useRef(null);
    const recordRef = useRef(null);
    const pulseRef = useRef(null);
    const currentHandlerRef = useRef(null);
    const audioChunksRef = useRef([]);
    const activeStreamRef = useRef(null);


const setupRecorderHandlers = (recorder) => {
  audioChunksRef.current = [];

  recorder.ondataavailable = (event) => {
    if (event.data && event.data.size > 0) {
      audioChunksRef.current.push(event.data);
    }
  };

  recorder.onerror = (event) => {
    console.error("Recorder error:", event);
  };
};

const buildRecordingBlob = (recorder) => {
  const chunks = audioChunksRef.current;
  if (!chunks.length) return null;

  const mimeType = recorder?.mimeType || getRecorderMimeType() || "audio/webm";
  const blob = new Blob(chunks, { type: mimeType });

  return blob.size > 0 ? blob : null;
};
    

    const isMobile = useIsMobile();

   const audioRecord = useRef(null);

// Narrator/source audio is public content.
// Prefer backend-provided audio_url if present, otherwise fall back to old full_path.
const fullaudio = file?.audio_url
  ? `${process.env.REACT_APP_USER_API_URL}${file.audio_url}`
  : `${process.env.REACT_APP_USER_API_URL}/${file.full_path}`;
    // ============================================
    // SECTION 3: UTILITY FUNCTIONS
    // ============================================
    const pulse_frames = [ 
        { transform: "scale(1)", opacity: "1" },
        { transform: "scale(1.1)", opacity: "0.8" },
        { transform: "scale(1)", opacity: "1" },
    ];

    const progress_frames = [ 
        { transform: "translateX(0)" },
        { transform: "translateX(176px)" },
        { transform: "translateX(0)" },
    ];

    // ============================================
    // SECTION 4: CORE FUNCTIONS
    // ============================================
    
    const timeUpdate = (event) => {
  const currentTime = event.target.currentTime;
  setBroadcastTime(currentTime - segment.start);

  if (segment?.hasOwnProperty("words")) {
    const foundword = segment.words.findIndex((word, i) => {
      const isLast = i === segment.words.length - 1;
      return isLast
        ? word.start <= currentTime && word.end >= currentTime
        : word.start <= currentTime && word.end > currentTime;
    });

    if (foundword !== -1 && currentWord !== foundword) {
      setCurrentWord(foundword);
    }
  }
};
   
 const sendBlob = ({ blob, subject, file, segment }) => {
  const token = localStorage.getItem("token");

  const url = `${process.env.REACT_APP_USER_API_URL}/analysis/upload_blob/${subject.owner}/${subject.language}/${subject.author}/${subject.title}/${file.file}/${subject.type}`;

  const blobType = (blob?.type || "").toLowerCase();
  const ext =
    blobType.includes("wav") ? "wav" :
    blobType.includes("ogg") ? "ogg" :
    blobType.includes("mp4") || blobType.includes("mpeg") ? "mp4" :
    "webm";

  const filename = `recording_${Date.now()}.${ext}`;

  const formData = new FormData();
  formData.append("uploaded_file", blob, filename);
  formData.append("sendText", JSON.stringify(segment));
  formData.append("tz", Intl.DateTimeFormat().resolvedOptions().timeZone);

  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  setLoading(true);
  setAssessment(null);

  axios
    .post(url, formData, { headers })
    .then((response) => {
      const data = response.data;

      setAssessment(data);
      setLoading(false);

      if (!isPublic) {
        const act = data?.activity;
        if (act && typeof act.daily_total_seconds === "number") {
          setTodaySeconds(act.daily_total_seconds);
        } else {
          fetchTodayActivity(subject.language);
        }
      }
    })
    .catch((error) => {
      const status = error?.response?.status;
      console.error("Error uploading file:", status, error);
      setLoading(false);

      if (token && (status === 401 || status === 403)) {
        handleAuthExpired();
        setAssessment({ error: "AUTH_EXPIRED" });
        return;
      }

      setAssessment({ error: "UPLOAD_FAILED" });
    });
};


const getTranslations = async (info) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/dictionary/get-translation`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
        body: JSON.stringify(info),
      }
    );

    if (response.status === 401 || response.status === 403) {
      handleAuthExpired(); // soften: remain on page
      return;
    }

    if (!response.ok) {
      console.warn("getTranslations failed:", response.status);
      return;
    }

    const json = await response.json();
    setTranslation(json);
  } catch (e) {
    console.error("getTranslations error:", e);
  }
};

/**
 * ✅ PUBLIC-OK (if backend allows it):
 * - sends auth header only if token exists
 * - does not redirect on 401/403
 * - keeps your existing model_size behavior
 */
const getSegments = async ({ subject, file }) => {
  const outdata = {
    author: subject.author,
    title: subject.title,
    language: subject.language,
    file,
    type: subject.type,
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/whisper/get-segments`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
        body: JSON.stringify(outdata),
      }
    );

    if (response.status === 401 || response.status === 403) {
      handleAuthExpired(); // soften: remain on page
      return;
    }

    if (!response.ok) {
      console.warn("getSegments failed:", response.status);
      return;
    }

    const json = await response.json();
    setSegments(json.segments);
    if (json.model_size) setModelSize(json.model_size);
  } catch (e) {
    console.error("getSegments error:", e);
  }
};

   const getMicrophonePermission = async () => {
  if (!("MediaRecorder" in window)) {
    alert("The MediaRecorder API is not supported in your browser.");
    return null;
  }

  try {
    const streamData = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });

    setIsGranted(true);
    setStream(streamData);

    return streamData;
  } catch (err) {
    console.error("Error getting microphone permission:", err);
    alert(err.message);
    return null;
  }
};

    // ============================================
    // SECTION 5: AUDIO PLAYBACK FUNCTIONS
    // ============================================
    
    const Play_record = () => {
  setTimeout(() => {
    if (!audioRecord.current) return;
    audioRecord.current.currentTime = 0;
    audioRecord.current.play();
  }, 300);
};
    const newreachedEnd = (segment) => {
        const handler = (event) => {
            const currentTime = event.target.currentTime;
            
            if (currentTime >= segment.end - 0.001) {
                audioref.current.pause();
                audioref.current.currentTime = segment.start;
                audioref.current.removeEventListener('timeupdate', handler);
                currentHandlerRef.current = null;
                setIsPlayingSegment(false);
                setCurrentWord(0);
                
                if (isShadowing && recordingStatus === "recording") {
                    setTimeout(() => {
                        if (shadowingTimeout) {
                            clearTimeout(shadowingTimeout);
                            setShadowingTimeout(null);
                        }
                        stopShadowingRecording(true);
                    }, 500);
                }
                
                // Check echoing phase from ref (synchronous)
                if (practiceMode === 'echoing' && echoingPhaseRef.current === 'playing') {
                    startEchoingCountdown();
                }
            }
        };
        return handler;
    };

    

    const handler = newreachedEnd(segment);

    // ============================================
    // SECTION 6: RECORDING FUNCTIONS
    // ============================================
    
 const startRecording = async (sendForAnalysis = true) => {
  let activeStream = stream;

  if (!(activeStream instanceof MediaStream)) {
    try {
      activeStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      setStream(activeStream);
      setIsGranted(true);
    } catch (err) {
      console.error("Could not get microphone stream:", err);
      return;
    }
  }

  if (!(activeStream instanceof MediaStream)) {
    console.error("startRecording: invalid MediaStream", activeStream);
    return;
  }

  setRecordingStatus("recording");
  setRecordingProgress(0);

  const maxTime = 3 * duration * 1000;
  setMaxRecordingTime(maxTime);

  const media = createRecorder(activeStream);

  mediaRecorder.current = media;
  mediaRecorderRef.current = media;

  setupRecorderHandlers(media);

  media.start();

  const startTime = Date.now();

  const updateProgress = () => {
    if (mediaRecorder.current?.state === "recording") {
      const elapsed = Date.now() - startTime;
      const progress = Math.min((elapsed / maxTime) * 100, 100);
      setRecordingProgress(progress);

      if (progress < 100) {
        requestAnimationFrame(updateProgress);
      }
    }
  };

  requestAnimationFrame(updateProgress);
};

const stopRecording = (sendForAnalysis = true) => {
  if (!mediaRecorder.current || mediaRecorder.current.state === "inactive") {
    return;
  }

  const recorder = mediaRecorder.current;

  if (sendForAnalysis) {
    setAssessment(null);
    setLoading(true);
  }

  setRecordingProgress(sendForAnalysis ? 100 : 0);

  if (recordRef.current) {
    recordRef.current.getAnimations().forEach((animation) => {
      animation.pause();
    });
  }

  setRecordingStatus("inactive");
  setHasRecording(sendForAnalysis);

  recorder.onstop = () => {
    if (sendForAnalysis) {
      const audioBlob = buildRecordingBlob(recorder);

      if (!audioBlob) {
        console.error("No recording blob created");
        setLoading(false);
        audioChunksRef.current = [];
        return;
      }

      const audioUrl = URL.createObjectURL(audioBlob);

      sendBlob({
        blob: audioBlob,
        subject,
        file,
        segment,
      });

      setAudio(audioUrl);
    }

    audioChunksRef.current = [];
  };

  recorder.stop();
};
    // ============================================
    // SECTION 6.5: PROCESS CANCELLATION FUNCTIONS
    // ============================================
    
    const silentCancelRecording = () => {
  setRecordingStatus("inactive");
  setRecordingProgress(0);
  setIsShadowing(false);
  setIsCueActive(false);
  setShowFirstWordCue(false);
  setCuePulseCount(0);
  setEchoingPhase("idle");
  echoingPhaseRef.current = "idle";
  setEchoingPulseCount(0);

  if (shadowingTimeout) clearTimeout(shadowingTimeout);
  if (echoingTimeout) clearTimeout(echoingTimeout);
  setShadowingTimeout(null);
  setEchoingTimeout(null);

  if (echoingTimeouts.length > 0) {
    echoingTimeouts.forEach((timeout) => timeout && clearTimeout(timeout));
    setEchoingTimeouts([]);
  }

  if (mediaRecorder.current && mediaRecorder.current.state !== "inactive") {
    try {
      mediaRecorder.current.onstop = null;
      mediaRecorder.current.stop();
    } catch (error) {
      console.error("Error stopping recorder:", error);
    }
  }

  setAudioChunks([]);
  audioChunksRef.current = [];

  [recordRef.current, pulseRef.current].forEach((ref) => {
    if (ref) {
      const animations = ref.getAnimations();
      if (animations) {
        animations.forEach((animation) => animation.cancel());
      }
    }
  });
};

    const cancelAllProcesses = () => {

        stopWordPlayRAF();
        if (recordingStatus === 'recording') {
            silentCancelRecording();
        }
        
        if (audioref.current) {
            audioref.current.pause();
            setIsPlayingSegment(false);
            
            if (currentHandlerRef.current) {
                audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
                currentHandlerRef.current = null;
            }
        }
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        setIsShadowing(false);
        setShowFirstWordCue(false);
        setIsCueActive(false);
    };

    // ============================================
    // SECTION 6.6: SHADOWING FUNCTIONS
    // ============================================
    
    const triggerFirstWordCue = () => {
        if (!segment || !segment.words || segment.words.length === 0) {
            console.error("Cannot trigger cue: segment or words missing");
            return;
        }
        
        setIsCueActive(true);
        setCuePulseCount(0);
        setShowFirstWordCue(true);
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        const newTimeouts = [];
        
        const timeout1 = setTimeout(() => {
            setCuePulseCount(1);
        }, SHADOWING_TIMING.PULSE_1_TIME);
        newTimeouts.push(timeout1);
        
        const timeout2 = setTimeout(() => {
            setCuePulseCount(2);
        }, SHADOWING_TIMING.PULSE_2_TIME);
        newTimeouts.push(timeout2);
        
        const timeout3 = setTimeout(() => {
            setCuePulseCount(3);
            
            const clearTimeoutId = setTimeout(() => {
                setIsCueActive(false);
                setShowFirstWordCue(false);
                setCuePulseCount(0);
            }, SHADOWING_TIMING.CUE_CLEAR_TIME);
            newTimeouts.push(clearTimeoutId);
        }, SHADOWING_TIMING.PULSE_3_TIME);
        newTimeouts.push(timeout3);
        
        setCueTimeouts(prev => [...prev, ...newTimeouts]);
        
        const recordingStartTime = SHADOWING_TIMING.AUDIO_START_DELAY + SHADOWING_TIMING.RECORDING_START_OFFSET;
        
        return recordingStartTime;
    };

  const startShadowing = async () => {
  let activeStream = stream;

  if (!(activeStream instanceof MediaStream)) {
    activeStream = await getMicrophonePermission();
  }

  if (!(activeStream instanceof MediaStream) || !segment) {
    console.error("Cannot start shadowing: stream or segment missing");
    return;
  }

  activeStreamRef.current = activeStream;

  if (shadowingTimeout) {
    clearTimeout(shadowingTimeout);
    setShadowingTimeout(null);
  }

  if (cueTimeouts.length > 0) {
    cueTimeouts.forEach((timeout) => timeout && clearTimeout(timeout));
    setCueTimeouts([]);
  }

  let recordingStartTime = 0;

  if (segment.words && segment.words.length > 0) {
    recordingStartTime = triggerFirstWordCue();
  }

  setIsShadowing(true);

  const recordingTimeout = setTimeout(() => {
    setRecordingStatus("recording");

    try {
      const media = createRecorder(activeStream);

      mediaRecorder.current = media;
      mediaRecorderRef.current = media;

      setupRecorderHandlers(media);

      media.start();

      const audioDelay = SHADOWING_TIMING.AUDIO_START_DELAY - recordingStartTime;

      const playTimeout = setTimeout(() => {
        if (audioref.current && segment?.start !== undefined) {
          setFocus(segment);
          audioref.current.currentTime = segment.start;
          audioref.current.play();

          if (currentHandlerRef.current) {
            audioref.current.removeEventListener(
              "timeupdate",
              currentHandlerRef.current
            );
          }

          currentHandlerRef.current = handler;
          audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
          setIsPlayingSegment(true);

          if (segment.start !== undefined && segment.end !== undefined) {
            const segmentDuration = (segment.end - segment.start) * 1000;
            const totalDuration =
              segmentDuration + SHADOWING_TIMING.POST_AUDIO_BUFFER;

            const stopTimeout = setTimeout(() => {
              if (mediaRecorder.current?.state === "recording") {
                stopShadowingRecording(true);
              }
            }, totalDuration);

            setShadowingTimeout(stopTimeout);
          }
        }
      }, Math.max(0, audioDelay));

      setCueTimeouts((prev) => [...prev, playTimeout]);
    } catch (error) {
      console.error("Error starting shadowing:", error);
      setIsShadowing(false);
      setRecordingStatus("inactive");
    }
  }, Math.max(0, recordingStartTime));

  setCueTimeouts((prev) => [...prev, recordingTimeout]);
};

    const stopShadowingRecording = (sendForAnalysis = true) => {
  if (sendForAnalysis) {
    setAssessment(null);
    setLoading(true);
  }

  setRecordingProgress(0);

  if (recordRef.current) {
    const animations = recordRef.current.getAnimations();
    if (animations) {
      animations.forEach((animation) => {
        if (animation && typeof animation.pause === "function") {
          animation.pause();
        }
      });
    }
  }

  setRecordingStatus("inactive");
  setIsShadowing(false);

  if (shadowingTimeout) {
    clearTimeout(shadowingTimeout);
    setShadowingTimeout(null);
  }

  if (cueTimeouts.length > 0) {
    cueTimeouts.forEach((timeout) => timeout && clearTimeout(timeout));
    setCueTimeouts([]);
  }

  setIsCueActive(false);
  setShowFirstWordCue(false);
  setCuePulseCount(0);

  if (!mediaRecorder.current || mediaRecorder.current.state === "inactive") {
    setIsShadowing(false);
    return;
  }

  const recorder = mediaRecorder.current;

  recorder.onstop = () => {
    if (sendForAnalysis) {
      const audioBlob = buildRecordingBlob(recorder);

      if (!audioBlob) {
        console.error("No shadowing recording blob created");
        setLoading(false);
        audioChunksRef.current = [];
        setAudioChunks([]);
        return;
      }

      const audioUrl = URL.createObjectURL(audioBlob);

      sendBlob({
        blob: audioBlob,
        subject,
        file,
        segment,
      });

      setAudio(audioUrl);
      setHasRecording(true);
    }

    audioChunksRef.current = [];
    setAudioChunks([]);
    setIsShadowing(false);
  };

  try {
    recorder.stop();
  } catch (error) {
    console.error("Error stopping shadow recording:", error);
    setLoading(false);
    setIsShadowing(false);
  }
};

    // ============================================
    // SECTION 6.7: ECHOING MODE FUNCTIONS - FIXED WITH SHORTER TIMING
    // ============================================
    
const startEchoingMode = async () => {
  let activeStream = stream;

  if (!(activeStream instanceof MediaStream)) {
    activeStream = await getMicrophonePermission();
  }

  if (!(activeStream instanceof MediaStream)) {
    return;
  }

  activeStreamRef.current = activeStream;

  cancelAllProcesses();

  setEchoingPhase("playing");
  echoingPhaseRef.current = "playing";

  if (audioref.current && segment && segment.hasOwnProperty("start")) {
    setFocus(segment);
    audioref.current.currentTime = segment.start;
    audioref.current.play();

    if (currentHandlerRef.current) {
      audioref.current.removeEventListener(
        "timeupdate",
        currentHandlerRef.current
      );
    }

    currentHandlerRef.current = handler;
    audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
    setIsPlayingSegment(true);
  }
};

    const startEchoingCountdown = () => {
        setEchoingPhase('paused');
        echoingPhaseRef.current = 'paused';
        setEchoingPulseCount(0);
        
        // Clear any existing timeouts
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        const newTimeouts = [];
        
        // Pulse 1 - 200ms
        const timeout1 = setTimeout(() => {
            setEchoingPulseCount(1);
        }, ECHOING_TIMING.PULSE_1_TIME);
        newTimeouts.push(timeout1);
        
        // Pulse 2 - 800ms
        const timeout2 = setTimeout(() => {
            setEchoingPulseCount(2);
        }, ECHOING_TIMING.PULSE_2_TIME);
        newTimeouts.push(timeout2);
        
        // Pulse 3 - 1600ms and start recording
        const timeout3 = setTimeout(() => {
            setEchoingPulseCount(3);
            
            // Clear the cue after 600ms (same as shadowing)
            const clearTimeoutId = setTimeout(() => {
                setEchoingPhase('recording');
                echoingPhaseRef.current = 'recording';
                startEchoingRecording();
            }, ECHOING_TIMING.CUE_CLEAR_TIME);
            newTimeouts.push(clearTimeoutId);
        }, ECHOING_TIMING.PULSE_3_TIME);
        newTimeouts.push(timeout3);
        
        setEchoingTimeouts(prev => [...prev, ...newTimeouts]);
    };

const startEchoingRecording = () => {
  const activeStream =
    stream instanceof MediaStream ? stream : activeStreamRef.current;

  if (!(activeStream instanceof MediaStream)) {
    console.error("Cannot start echoing recording: invalid stream", activeStream);
    setEchoingPhase("idle");
    echoingPhaseRef.current = "idle";
    setRecordingStatus("inactive");
    return;
  }

  setRecordingStatus("recording");
  setRecordingProgress(0);

  const maxTime = 3 * duration * 1000;
  setMaxRecordingTime(maxTime);

  const media = createRecorder(activeStream);

  mediaRecorder.current = media;
  mediaRecorderRef.current = media;

  setupRecorderHandlers(media);

  media.start();

  const stopTimeout = setTimeout(() => {
    if (
      mediaRecorder.current?.state === "recording" &&
      echoingPhaseRef.current === "recording"
    ) {
      stopEchoingRecording(true);
    }
  }, maxTime);

  setEchoingTimeout(stopTimeout);
};

 const stopEchoingRecording = (sendForAnalysis = true) => {
  if (sendForAnalysis) {
    setAssessment(null);
    setLoading(true);
  }

  setRecordingProgress(0);

  if (echoingTimeout) {
    clearTimeout(echoingTimeout);
    setEchoingTimeout(null);
  }

  if (echoingTimeouts.length > 0) {
    echoingTimeouts.forEach((timeout) => timeout && clearTimeout(timeout));
    setEchoingTimeouts([]);
  }

  setEchoingPhase("idle");
  echoingPhaseRef.current = "idle";
  setEchoingPulseCount(0);
  setRecordingStatus("inactive");

  if (!mediaRecorder.current || mediaRecorder.current.state === "inactive") {
    return;
  }

  const recorder = mediaRecorder.current;

  recorder.onstop = () => {
    if (sendForAnalysis) {
      const audioBlob = buildRecordingBlob(recorder);

      if (!audioBlob) {
        console.error("No echoing recording blob created");
        setLoading(false);
        audioChunksRef.current = [];
        setAudioChunks([]);
        return;
      }

      const audioUrl = URL.createObjectURL(audioBlob);

      sendBlob({
        blob: audioBlob,
        subject,
        file,
        segment,
      });

      setAudio(audioUrl);
      setHasRecording(true);
    }

    audioChunksRef.current = [];
    setAudioChunks([]);
  };

  try {
    recorder.stop();
  } catch (error) {
    console.error("Error stopping echo recording:", error);
    setLoading(false);
  }
};

    const cancelEchoingMode = () => {
        cancelAllProcesses();
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
    };

    // ============================================
    // SECTION 7: UI HANDLER FUNCTIONS
    // ============================================
    
    const handleWordClick = (word) => {
        if (!word || !subject || !subject.language) return;
        
        getTranslations({"word": word, "tolanguage": "English", "fromlanguage": subject.language});
        
        if (isMobile) {
  setShowTranslationModal(true);
} else {
  setSidebarCollapsed(false);
}
    };



    const handlePreviousSegment = () => {
        if (segment && segment["id"] !== 0 && segments) {
            cancelAllProcesses();
            
            setAssessment(null);
            setLoading(false);
            setTranslation();
            
            if (audioref.current) {
                audioref.current.currentTime = segments[segment["id"] - 1]["start"];
            }
            setSegment(segments[segment["id"] - 1]);
            setCurrentWord(0);
        }
    };

    const handleNextSegment = () => {
        if (segment && segment["id"] <= segments.length - 2 && segments) {
            cancelAllProcesses();
            
            setAssessment(null);
            setLoading(false);
            setTranslation();
            
            if (audioref.current) {
                audioref.current.currentTime = segments[segment["id"] + 1]["start"] + 0.01;
            }
            setSegment(segments[segment["id"] + 1]);
            setCurrentWord(0);
        }
    };

   

   const handleWordPlay = (i, item) => {
  if (!segment?.words?.length || !item) return;

  cancelAllProcesses();   // stop anything else
  setFocus(segment);
  setIsPlayingSegment(true);

  const startTime = i > 0 ? segment.words[i - 1].start : item.start;
  const endTime = item.end;

  playRangePrecise(startTime, endTime);
};

const handleRangePlay = ({
  startIndex,
  endIndex,
}) => {
  if (!segment?.words?.length) return;

  cancelAllProcesses();
  setFocus(segment);
  setIsPlayingSegment(true);

  const actualStartIndex = Math.max(0, startIndex - 1);

  const startTime = segment.words[actualStartIndex].start;
  const endTime = segment.words[endIndex].end;

  playRangePrecise(startTime, endTime);
};
    // ============================================
    // SECTION 8: MAIN ACTION HANDLER
    // ============================================
    
    const handleMainAction = () => {
        switch (practiceMode) {
            case 'echoing':
                if (echoingPhase === 'idle') {
                    startEchoingMode();
                } else if (echoingPhase === 'recording') {
                    stopEchoingRecording(true);
                } else {
                    cancelEchoingMode();
                }
                break;
                
            case 'shadowing':
                if (!isShadowing && recordingStatus === 'inactive') {
                    startShadowing();
                } else if (recordingStatus === 'recording') {
                    stopShadowingRecording(true);
                }
                break;
                
            case 'manual':
                if (recordingStatus === 'inactive') {
                    startRecording(true);
                } else {
                    stopRecording(true);
                }
                break;
        }
    };

    // ============================================
    // SECTION 9: KEYBOARD SHORTCUT HANDLERS
    // ============================================
    
    const handlePlayPause = () => {
        if (audioref.current && segment && segment.hasOwnProperty("start")) {
            if (audioref.current.paused) {
                setFocus(segment);
                audioref.current.currentTime = segment["start"];
                audioref.current.play();
                if (currentHandlerRef.current) {
                    audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
                }
                currentHandlerRef.current = handler;
                audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
                setIsPlayingSegment(true);
            } else {
                audioref.current.pause();
                setIsPlayingSegment(false);
            }
        }
    };

    const handleEscape = () => {
        cancelAllProcesses();
    };

    const cycleVisualizationView = () => {
        const views = ['pitch', 'intensity', 'music', 'colors', 'combined'];
        const currentIndex = views.indexOf(visualizationView);
        const nextIndex = (currentIndex + 1) % views.length;
        setVisualizationView(views[nextIndex]);
    };

    // ============================================
    // SECTION 10: VISUAL COMPONENTS
    // ============================================

    // Get button configuration based on mode and state
    const getButtonConfig = () => {
        if (practiceMode === 'echoing') {
            switch (echoingPhase) {
                case 'idle': 
                    return { 
                        text: 'Start Echoing', 
                        color: 'from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600',
                        icon: '🔄',
                        disabled: false
                    };
                case 'playing': 
                    return { 
                        text: 'Playing...', 
                        color: 'from-blue-400 to-indigo-400',
                        icon: '▶️',
                        disabled: true
                    };
                case 'paused': 
                    return { 
                        text: 'Get Ready...', 
                        color: 'from-amber-500 to-orange-500',
                        icon: '⏳',
                        disabled: true
                    };
                case 'recording': 
                    return { 
                        text: 'Stop Recording', 
                        color: 'from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600',
                        icon: '⏹️',
                        disabled: false
                    };
            }
        }
        
        if (practiceMode === 'shadowing') {
            if (isShadowing && recordingStatus === 'recording') {
                return { 
                    text: 'Stop Shadowing', 
                    color: 'from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600',
                    icon: '⏹️',
                    disabled: false
                };
            }
            return { 
                text: 'Shadow & Record', 
                color: 'from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600',
                icon: '🎭',
                disabled: recordingStatus !== 'inactive'            
              };
        }
        
        if (practiceMode === 'manual') {
            if (recordingStatus === 'recording') {
                return { 
                    text: 'Stop Recording', 
                    color: 'from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600',
                    icon: '⏹️',
                    disabled: false
                };
            }
            return { 
                text: 'Start Recording', 
                color: 'from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600',
                icon: '⏺️',
                disabled: !isgranted
            };
        }
        
        // Default
        return { 
            text: 'Start', 
            color: 'from-blue-500 to-indigo-500',
            icon: '▶️',
            disabled: false
        };
    };

  
    
// ================================
// HELP SYSTEM (metadata-controlled)
// ================================
const helpCfg = course?.help ?? course?.metadata?.help ?? {
  enabled: false,
  mode: "none", // "exercise" | "about" | "none"
};

const helpEnabled = !!helpCfg?.enabled;
const helpMode = helpCfg?.mode || "none";

const currentContextItem =
  helpEnabled &&
  helpMode === "context" &&
  Array.isArray(course?.context) &&
  file?.file
    ? course.context.find((item) => {
        const localPath = item?.local_audio_path || "";
        const localBase = String(localPath).split("/").pop();
        return localBase === file.file;
      }) || null
    : null;

const hasContextHelp = helpMode === "context" && !!currentContextItem;

// Derive exercise id (1A / 2B etc)
const exerciseId = deriveExerciseId(subject, file);

// Exercise lookup (only when in exercise mode)
const currentExercise =
  helpEnabled &&
  helpMode === "exercise" &&
  exerciseId &&
  Array.isArray(course?.exercises)
    ? course.exercises.find(
        (e) => String(e.id).toUpperCase() === String(exerciseId).toUpperCase()
      ) || null
    : null;

const hasExerciseHelp = helpMode === "exercise" && !!currentExercise;

// About-only mode
const isMetadataNoHelp = helpEnabled && helpMode === "about";
const isAboutOnly = helpEnabled && helpMode === "about";

// Header title / action label
const headerTitle =
  helpMode === "context"
    ? (currentContextItem?.place || sectionTitle || "Dialect sample")
    : isMetadataNoHelp
      ? (sectionTitle || "Exercise")
      : (exerciseId ? `Exercise ${exerciseId}` : (sectionTitle || "Exercise"));

const helpActionLabel =
  helpMode === "context"
    ? (helpCfg?.buttonLabel || "Dialect info")
    : isMetadataNoHelp
      ? "About course"
      : (helpCfg?.buttonLabel || "What to focus on");

// Center label
const sentenceLabel = segments
  ? `Sentence ${segment.id + 1}/${segments.length}`
  : "Sentence";

// Cues
const showShadowCue =
  practiceMode === "shadowing" &&
  (isCueActive || recordingStatus === "recording");

const showEchoCue =
  practiceMode === "echoing" && echoingPhase === "paused";

const showCenterCue = showShadowCue || showEchoCue;


const introAnchorTitle = currentExercise?.studentAnchor?.title || "";
const introAnchorSubtitle = currentExercise?.studentAnchor?.subtitle || "";
const introPattern =
  Array.isArray(currentExercise?.patterns) && currentExercise.patterns.length
    ? currentExercise.patterns[0]
    : "";

const canRunHelpIntro =
  helpEnabled &&
  helpMode === "exercise" &&
  !!currentExercise &&
  !!introAnchorTitle;


// ============================================
    // SECTION 11: EFFECTS
    // ============================================
    
useEffect(() => {
  return () => {
    if (protectedAssessmentAudioUrl) {
      URL.revokeObjectURL(protectedAssessmentAudioUrl);
    }
    if (protectedNarratorAudioUrl) {
      URL.revokeObjectURL(protectedNarratorAudioUrl);
    }
  };
}, [protectedAssessmentAudioUrl, protectedNarratorAudioUrl]);

useEffect(() => {
  fetchCommentCounts();
}, [subject, file?.file, segment?.start, segment?.end, segment?.text]);

useEffect(() => {
  let cancelled = false;
  let oldAssessmentBlob = protectedAssessmentAudioUrl;
  let oldNarratorBlob = protectedNarratorAudioUrl;

  const loadProtectedAudio = async () => {
    if (!assessment) {
      if (oldAssessmentBlob) URL.revokeObjectURL(oldAssessmentBlob);
      if (oldNarratorBlob) URL.revokeObjectURL(oldNarratorBlob);

      if (!cancelled) {
        setProtectedAssessmentAudioUrl(null);
        setProtectedNarratorAudioUrl(null);
      }
      return;
    }

    const userAudioPath =
      assessment?.audio_url ||
      assessment?.intonation?.audio_url ||
      null;

    const narratorAudioPath =
      assessment?.narrator_intonation?.audio_url ||
      null;

    let nextAssessmentBlob = null;
    let nextNarratorBlob = null;

    if (userAudioPath && userAudioPath.includes("/audio/private/")) {
      nextAssessmentBlob = await fetchProtectedAudioBlobUrl(userAudioPath);
    }

    if (narratorAudioPath && narratorAudioPath.includes("/audio/private/")) {
      nextNarratorBlob = await fetchProtectedAudioBlobUrl(narratorAudioPath);
    }

    if (cancelled) {
      if (nextAssessmentBlob) URL.revokeObjectURL(nextAssessmentBlob);
      if (nextNarratorBlob) URL.revokeObjectURL(nextNarratorBlob);
      return;
    }

    if (oldAssessmentBlob) URL.revokeObjectURL(oldAssessmentBlob);
    if (oldNarratorBlob) URL.revokeObjectURL(oldNarratorBlob);

    setProtectedAssessmentAudioUrl(nextAssessmentBlob);
    setProtectedNarratorAudioUrl(nextNarratorBlob);
  };

  loadProtectedAudio();

  return () => {
    cancelled = true;
  };
}, [assessment]);
    useEffect(() => {
  const key = subject?.course_key;

  // No course_key => no help system
  if (!key) {
    setCourse(null);
    return;
  }

  let alive = true;


  loadCourse(key)
    .then((c) => {
      if (!alive) return;
      setCourse(c);
    })
    .catch((err) => {
      console.warn("loadCourse failed:", err);
      if (!alive) return;
      setCourse(null);
    })
    .finally(() => {
      if (!alive) return;
    
    });

  return () => {
    alive = false;
  };
}, [subject?.course_key]);

useEffect(() => {
  if (!canRunHelpIntro) {
    setShowHelpIntro(false);
    return;
  }

  const introKey = `${subject?.course_key || ""}__${exerciseId || ""}`;

  if (lastIntroKeyRef.current === introKey) return;
  lastIntroKeyRef.current = introKey;

  setShowHelpIntro(true);

  if (helpIntroTimerRef.current) {
    clearTimeout(helpIntroTimerRef.current);
  }

  helpIntroTimerRef.current = setTimeout(() => {
    setShowHelpIntro(false);
    helpIntroTimerRef.current = null;
  }, 2000);

  return () => {
    if (helpIntroTimerRef.current) {
      clearTimeout(helpIntroTimerRef.current);
      helpIntroTimerRef.current = null;
    }
  };
}, [canRunHelpIntro, exerciseId, subject?.course_key]);

useEffect(() => {
  if (!showHelpIntro) return;

  const userIsActive =
    isPlayingSegment ||
    recordingStatus === "recording" ||
    isShadowing ||
    (practiceMode === "echoing" && echoingPhase !== "idle");

  if (userIsActive) {
    setShowHelpIntro(false);
    if (helpIntroTimerRef.current) {
      clearTimeout(helpIntroTimerRef.current);
      helpIntroTimerRef.current = null;
    }
  }
}, [
  showHelpIntro,
  isPlayingSegment,
  recordingStatus,
  isShadowing,
  practiceMode,
  echoingPhase,
]);

    useEffect(() => {
  if (!audio) return;
  audioRecord.current = new Audio(audio);
  return () => {
    if (audioRecord.current) {
      audioRecord.current.pause();
      audioRecord.current = null;
    }
  };
}, [audio]);

   useEffect(() => {
  if (!isPublic && subject?.language) fetchDailyGoal(subject.language);
}, [isPublic, subject?.language]);

    useEffect(() => {
        setSegments(null);
        setAssessment(null);
        setAudio(null);
        setRecordingStatus("inactive");
        setAudioChunks([]);
        setHasRecording(false);
        setLoading(false);
        setTranslation(null);
        setCurrentWord(0);
        setBroadcastTime(0);
        setIsPlayingSegment(false);
        
        setIsShadowing(false);
        setShowFirstWordCue(false);
        setCuePulseCount(0);
        setIsCueActive(false);
        setRecordingProgress(0);
        setMaxRecordingTime(0);
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        if (file && file.file) {
            getSegments({"subject": subject, "file": file.file});
        }
        
        if (audioRecordRef.current) {
            audioRecordRef.current.pause();
            audioRecordRef.current = null;
        }
    }, [file, subject]);

    useEffect(() => {
        if (navigator) {
            navigator.permissions
                .query({ name: "microphone" })
                .then(async function (result) {
                    if (result.state === "granted") {
                        if ("MediaRecorder" in window) {
                            try {
                                const streamData = await navigator.mediaDevices.getUserMedia({
                                    audio: true,
                                    video: false,
                                });
                                setIsGranted(true);
                                setStream(streamData);
                            } catch (err) {
                                alert(err.message);
                            }
                        } else {
                            alert("The MediaRecorder API is not supported in your browser.");
                        }
                   } else if (result.state === "prompt") {
                          console.log("Microphone permission prompt will be shown");


                    } else if (result.state === "denied") {
                        // Handle denied case
                    }
                });
        } else {
            console.log("navigator is not supported by this browser.");
        }
    }, []);

    useEffect(() => {
     
        if (segments) {
            if (Object.keys(segment).length === 0) {
                setSegment(segments[0]);
            }
        };  
        setAssessment(null); 
        setRate(1); 
        setLoading(false); 
        setTranslation();
        setIsPlayingSegment(false);
        setCurrentWord(0);
        setIsShadowing(false);
        setShowFirstWordCue(false);
        setCuePulseCount(0);
        setIsCueActive(false);
        setRecordingProgress(0);
        setMaxRecordingTime(0);
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        
        setPracticeMode(preservedMode);
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
    }, [file, subject, segments]);

    

    useEffect(() => {
  if (!isPublic && subject?.language) fetchTodayActivity(subject.language);
}, [isPublic, subject?.language]);

    useEffect(() => {
       
        if (segment) {
            if ( segment.hasOwnProperty("end") && segment.hasOwnProperty("start")) { 
                if (segment.end - segment.start > 0) {
                    setDuration(segment.end - segment.start);
                }
            }
        }
    }, [segment]);
    
    useEffect(() => {
  if (recordingStatus !== "recording") return;

  let rafId;
  let stopTimer;

  const preAudioBuffer = Math.abs(SHADOWING_TIMING.RECORDING_START_OFFSET);
  const postAudioBuffer = SHADOWING_TIMING.POST_AUDIO_BUFFER;
  const extraTime =
    practiceMode === "shadowing" ? preAudioBuffer + postAudioBuffer : 0;

  const totalDuration = 3 * duration * 1000 + extraTime;
  const startedAt = performance.now();

  setRecordingProgress(0);

  const tick = (now) => {
    const elapsed = now - startedAt;
    const nextProgress = Math.min((elapsed / totalDuration) * 100, 100);

    setRecordingProgress(nextProgress);

    if (nextProgress < 100) {
      rafId = requestAnimationFrame(tick);
    }
  };

  rafId = requestAnimationFrame(tick);

  stopTimer = setTimeout(() => {
    if (recordingStatus === "recording") {
      if (practiceMode === "echoing") {
        stopEchoingRecording(true);
      } else if (practiceMode === "shadowing") {
        stopShadowingRecording(true);
      } else {
        stopRecording(true);
      }
    }
  }, totalDuration);

  return () => {
    cancelAnimationFrame(rafId);
    clearTimeout(stopTimer);
  };
}, [recordingStatus, duration, practiceMode]);
    useEffect(() => {
        if (recordingStatus === "inactive") {
            setRecordingProgress(0);
        }
    }, [recordingStatus]);

    // Update echoingPhaseRef when echoingPhase changes
    useEffect(() => {
        echoingPhaseRef.current = echoingPhase;
    }, [echoingPhase]);

    // Keyboard Navigation Effect
  useEffect(() => {
    const handleKeyPress = (event) => {
        if (showExerciseHelp) return;
        if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
            return;
        }

        switch (event.key) {
            case 'ArrowLeft':
            case 'a':
            case 'A':
                event.preventDefault();
                handlePreviousSegment();
                break;

            case 'ArrowRight':
            case 'd':
            case 'D':
                event.preventDefault();
                handleNextSegment();
                break;

            case ' ':
                event.preventDefault();
                handlePlayPause();
                break;

            case 'r':
            case 'R':
                event.preventDefault();
                handleMainAction(); // R now works for ALL modes
                break;

            case 'p':
            case 'P':
                event.preventDefault();
                if (hasRecording && audio) {
                    Play_record();
                }
                break;

            case 'Escape':
                event.preventDefault();
                handleEscape();
                break;

            case '?':
                event.preventDefault();
                setShowKeyboardHelp(prev => !prev);
                break;

            case '1':
                event.preventDefault();
                setRate(1);
                if (audioref.current) audioref.current.playbackRate = 1;
                break;

            case '2':
                event.preventDefault();
                setRate(0.5);
                if (audioref.current) audioref.current.playbackRate = 0.5;
                break;

            case '3':
                event.preventDefault();
                setRate(0.25);
                if (audioref.current) audioref.current.playbackRate = 0.25;
                break;

            case 'm':
            case 'M':
                event.preventDefault();
                setShowIntonationVisualization(prev => !prev);
                break;

            case 'v':
            case 'V':
                event.preventDefault();
                cycleVisualizationView();
                break;

            case 't':
            case 'T':
                event.preventDefault();
                // Cycle through practice modes: echoing -> shadowing -> manual -> echoing
                const modes = ['echoing', 'shadowing', 'manual'];
                const currentIndex = modes.indexOf(practiceMode);
                const nextIndex = (currentIndex + 1) % modes.length;
                cancelAllProcesses();
                setPracticeMode(modes[nextIndex]);
                setPreservedMode(modes[nextIndex]);
                break;
        }
    };

    keyboardListenerRef.current = handleKeyPress;
    document.addEventListener('keydown', handleKeyPress);
    return () => {
        document.removeEventListener('keydown', handleKeyPress);
    };
}, [segment, segments, isgranted, recordingStatus, hasRecording, audio, visualizationView, activeTab, handler, practiceMode, echoingPhase, showExerciseHelp]);
    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileMenuOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.hamburger-button')) {
                setMobileMenuOpen(false);
            }
            if (showKeyboardHelp && !event.target.closest('.keyboard-help') && !event.target.closest('.keyboard-help-button')) {
                setShowKeyboardHelp(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [mobileMenuOpen, showKeyboardHelp]);

    // Cleanup timeouts on unmount
    useEffect(() => {
        return () => {
            cancelAllProcesses();
            
            if (audioRecordRef.current) {
                audioRecordRef.current.pause();
                audioRecordRef.current = null;
            }
            
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
                try {
                    mediaRecorderRef.current.stop();
                } catch (error) {
                    console.error("Error cleaning up media recorder:", error);
                }
            }
            
            if (audioref.current) {
                if (currentHandlerRef.current) {
                    audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
                }
                
            }
            
            if (keyboardListenerRef.current) {
                document.removeEventListener('keydown', keyboardListenerRef.current);
            }
        };
    }, []);

    // ============================================
    // SECTION 12: MAIN RENDER
    // ============================================
    return (
     <div className="flex flex-col xl:flex-row h-[100dvh] w-full overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">

            {/* Keyboard Help Modal */}
            <KeyboardHelpModal 
                showKeyboardHelp={showKeyboardHelp} 
                setShowKeyboardHelp={setShowKeyboardHelp} 
            />
            
           

            {/* Desktop Sidebar */}
<div
  className={[
    "hidden xl:flex flex-none flex-col gap-4 transition-all duration-300 h-full min-h-0 overflow-y-auto",
    "bg-white/20 backdrop-blur-sm border-r border-white/30",
sidebarCollapsed ? "xl:w-28 items-center px-4 py-4" : "xl:w-96 p-4",  ].join(" ")}
>
 {sidebarCollapsed ? (
  <>
    {/* Expand */}
    <button
      onClick={() => setSidebarCollapsed(false)}
      className="
        group relative mt-1
        w-14 h-14 rounded-2xl
        bg-gradient-to-br from-blue-600 to-indigo-600
        text-white shadow-xl shadow-blue-500/25
        hover:scale-105 active:scale-95
        transition-all flex items-center justify-center
      "
      title="Expand sidebar"
    >
      <BsArrowsExpand className="text-[26px] rotate-90" />

      <span className="absolute left-full ml-3 px-3 py-2 rounded-xl bg-slate-900 text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition pointer-events-none">
        Expand sidebar
      </span>
    </button>

    <div className="w-8 h-px bg-slate-300 my-2" />

    {/* Daily progress */}
    {!isPublic && (() => {
      const pct = Math.min(
        100,
        Math.max(
          0,
          Math.round((todaySeconds / Math.max(goalSeconds || 1, 1)) * 100)
        )
      );

      const radius = 18;
      const circumference = 2 * Math.PI * radius;
      const dashOffset = circumference - (pct / 100) * circumference;

      const tone =
        pct < 35
          ? {
              label: "Warming up",
              border: "border-orange-200",
              bg: "bg-orange-50",
              dot: "bg-orange-400",
              id: "warm",
              stops: ["#f59e0b", "#f97316"],
            }
          : pct < 75
          ? {
              label: "On track",
              border: "border-blue-200",
              bg: "bg-blue-50",
              dot: "bg-blue-400",
              id: "track",
              stops: ["#3b82f6", "#6366f1"],
            }
          : {
              label: "Goal crushing",
              border: "border-emerald-200",
              bg: "bg-emerald-50",
              dot: "bg-emerald-400",
              id: "crush",
              stops: ["#10b981", "#14b8a6"],
            };

      return (
        <button
          onClick={() => setShowProgressModal(true)}
          className={`
            group relative
            w-16 h-16 rounded-3xl
            bg-white border ${tone.border}
            shadow-sm hover:shadow-xl
            hover:-translate-y-0.5
            transition-all
            flex items-center justify-center
            ${pct >= 75 ? "shadow-emerald-500/10" : ""}
          `}
          title={`${tone.label} · ${pct}%`}
        >
          <div className={`absolute inset-1 rounded-[1.3rem] ${tone.bg}`} />

          {pct >= 75 && (
            <div className="absolute inset-0 rounded-3xl bg-emerald-400/10 animate-pulse" />
          )}

          <svg
            className="absolute inset-0 m-auto w-14 h-14 -rotate-90"
            viewBox="0 0 44 44"
          >
            <circle
              cx="22"
              cy="22"
              r={radius}
              fill="none"
              stroke="rgba(148,163,184,.22)"
              strokeWidth="4"
            />

            <circle
              cx="22"
              cy="22"
              r={radius}
              fill="none"
              stroke={`url(#${tone.id})`}
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={dashOffset}
              className="transition-all duration-700 ease-out"
            />

            <defs>
              <linearGradient id={tone.id}>
                <stop offset="0%" stopColor={tone.stops[0]} />
                <stop offset="100%" stopColor={tone.stops[1]} />
              </linearGradient>
            </defs>
          </svg>

          <div className="relative">
            <span className="text-[24px] leading-none drop-shadow-sm">
              {getLanguageFlag(subject?.language)}
            </span>

            <span
              className={`
                absolute -top-1 -right-1
                w-2.5 h-2.5 rounded-full
                ring-2 ring-white shadow-sm
                ${tone.dot}
              `}
            />
          </div>

          <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 px-3 py-2 rounded-xl bg-slate-900 text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition pointer-events-none shadow-lg">
            {tone.label} · {pct}%
          </span>
        </button>
      );
    })()}

    {/* Practice modes */}
    {[
      {
        mode: "echoing",
        label: "Echo Mode",
        shortcut: "R",
        activeColor: "bg-gradient-to-br from-blue-500 to-indigo-600",
        icon:
          practiceMode === "echoing" && recordingStatus === "recording"
            ? "🔴"
            : practiceMode === "echoing" && echoingPhase === "playing"
            ? "▶️"
            : "🔄",
      },
      {
        mode: "shadowing",
        label: "Shadow Mode",
        shortcut: "R",
        activeColor: "bg-gradient-to-br from-amber-500 to-orange-600",
        icon:
          practiceMode === "shadowing" && recordingStatus === "recording"
            ? "🔴"
            : practiceMode === "shadowing" && isPlayingSegment
            ? "▶️"
            : "🎭",
      },
      {
        mode: "manual",
        label: "Manual Mode",
        shortcut: "R",
        activeColor: "bg-gradient-to-br from-emerald-500 to-green-600",
        icon: practiceMode === "manual" && recordingStatus === "recording" ? "🔴" : "🎮",
      },
    ].map(({ mode, icon, label, shortcut, activeColor }) => {
      const active = practiceMode === mode;

      return (
        <button
          key={mode}
          onClick={() => {
            cancelAllProcesses();
            setPracticeMode(mode);
            setPreservedMode(mode);
          }}
          className="group relative"
          title={label}
        >
          {active && (
            <span className="absolute -left-3 top-1/2 -translate-y-1/2 w-1 h-7 rounded-full bg-blue-500 shadow-sm" />
          )}

          <div
            className={[
              "relative w-12 h-12 rounded-xl flex items-center justify-center border transition-all",
              "hover:-translate-y-0.5",
              active
                ? `${activeColor} text-white border-transparent shadow-lg`
                : "bg-white border-slate-200 hover:bg-slate-50 shadow-sm",
            ].join(" ")}
          >
            <span className={active && recordingStatus === "recording" ? "animate-pulse" : ""}>
              {icon}
            </span>
          </div>

          <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 px-3 py-2 rounded-xl bg-slate-900 text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition pointer-events-none shadow-lg">
            {label} · Press {shortcut}
          </span>
        </button>
      );
    })}

    <div className="w-8 h-px bg-slate-300 my-2" />

    {/* Visualization modes */}
    {[
      {
        key: "pitch",
        icon: "📈",
        label: "Pitch View",
        color: "text-blue-600",
        active: "bg-gradient-to-br from-blue-500 to-cyan-500",
      },
      {
        key: "intensity",
        icon: "🔊",
        label: "Intensity View",
        color: "text-orange-600",
        active: "bg-gradient-to-br from-orange-500 to-red-500",
      },
      {
        key: "music",
        icon: "🎵",
        label: "Music Notes",
        color: "text-violet-600",
        active: "bg-gradient-to-br from-purple-500 to-pink-500",
      },
      {
        key: "colors",
        icon: "🎨",
        label: "Color Words",
        color: "text-emerald-600",
        active: "bg-gradient-to-br from-green-500 to-emerald-500",
      },
      {
        key: "combined",
        icon: "🎛️",
        label: "Combined View",
        color: "text-indigo-600",
        active: "bg-gradient-to-br from-indigo-500 to-purple-500",
      },
    ].map(({ key, icon, label, color, active }) => {
      const selected = visualizationView === key;

      return (
        <button
          key={key}
          onClick={() => setVisualizationView(key)}
          title={label}
          className="group relative"
        >
          {selected && (
            <span className="absolute -left-3 top-1/2 -translate-y-1/2 w-1 h-7 rounded-full bg-purple-500 shadow-sm" />
          )}

          <div
            className={[
              "w-12 h-12 rounded-xl flex items-center justify-center border transition-all",
              "hover:-translate-y-0.5",
              selected
                ? `${active} text-white border-transparent shadow-lg`
                : `bg-white border-slate-200 hover:bg-slate-50 shadow-sm ${color}`,
            ].join(" ")}
          >
            {icon}
          </div>

          <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 px-3 py-2 rounded-xl bg-slate-900 text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition pointer-events-none shadow-lg">
            {label} · Press V
          </span>
        </button>
      );
    })}

    <div className="flex-1 min-h-8" />

    {/* Keyboard shortcuts */}
   <button
  onClick={() => setShowKeyboardHelp(true)}
  className="
    mt-auto mb-5
    group relative
    w-14 h-14 rounded-2xl
    bg-gradient-to-br from-slate-700 to-slate-900
    text-white
    shadow-xl shadow-slate-500/20
    hover:shadow-2xl hover:-translate-y-0.5
    hover:scale-[1.03]
    active:scale-95
    transition-all duration-300
    flex items-center justify-center
    ring-1 ring-white/10
  "
  title="Keyboard shortcuts (?)"
>
  <MdKeyboard className="text-[24px] group-hover:scale-110 transition-transform duration-300" />

  {/* quiet by default, pulses only on hover */}
  <span
    className="
      absolute top-2 right-2
      w-2 h-2 rounded-full
      bg-cyan-400
      opacity-70
      shadow-[0_0_8px_rgba(34,211,238,.35)]
      group-hover:animate-pulse
      group-hover:opacity-100
    "
  />

  {/* tooltip */}
  <span
    className="
      absolute left-full ml-3
      px-3 py-2 rounded-xl
      bg-slate-900 text-white text-xs font-semibold
      whitespace-nowrap
      opacity-0 group-hover:opacity-100
      transition pointer-events-none
      shadow-xl
    "
  >
    Keyboard Shortcuts · press ?
  </span>
</button>
  </>
) : (
    <>
      {/* Translation Panel - Desktop */}
      {translation && (
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-gray-800 flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center text-white text-sm">
                🌐
              </div>
              Translation
            </h3>
            <button
              onClick={() => setTranslation()}
              className="p-2 hover:bg-white/60 rounded-xl transition-all duration-200 border border-white/40"
            >
              <span className="text-gray-500 text-lg">×</span>
            </button>
          </div>

          {translation.translation[0]?.hasOwnProperty("normalizedSource") ? (
            <div className="text-left space-y-3">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-3 border border-blue-200/50">
                <p className="font-semibold text-gray-800">
                  {translation.translation[0].normalizedSource}
                </p>
                <p className="text-xs text-gray-500 mt-1">normalized form</p>
              </div>
              <ul className="space-y-2 text-sm">
                {translation.translation[0].translations.map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 p-2 rounded-lg bg-white/50 border border-white/40"
                  >
                    <span className="font-bold text-blue-500 bg-blue-100 rounded-lg px-2 py-1 text-xs">
                      {i + 1}
                    </span>
                    <span className="text-gray-700 flex-1">
                      {item.displayTarget}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ) : translation.translation === "missing translation" ? (
            <div className="text-center text-gray-500 py-4 bg-white/50 rounded-xl border border-white/40">
              <div className="text-2xl mb-2">🔍</div>
              <p>Translation not available</p>
            </div>
          ) : (
            <div className="text-left space-y-3">
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-3 border border-green-200/50">
                <p className="font-semibold text-gray-800">
                  {translation.word}
                </p>
              </div>
              <ul className="space-y-2 text-sm">
                {translation.translation[0].translations.map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 p-2 rounded-lg bg-white/50 border border-white/40"
                  >
                    <span className="font-bold text-green-500 bg-green-100 rounded-lg px-2 py-1 text-xs">
                      {i + 1}
                    </span>
                    <span className="text-gray-700 flex-1">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {!isPublic && (
        <div className="flex justify-center">
          <ProgressPill
            language={subject?.language || "en"}
            showLanguageFlag={true}
            doneSeconds={todaySeconds}
            goalSeconds={goalSeconds}
            onClick={() => setShowProgressModal(true)}
            collapsed={false}
          />
        </div>
      )}

      {/* Practice Mode Panel */}
<div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0">
  
  {/* Header */}
  <div className="flex items-center justify-between gap-3 mb-4">
    <h2 className="font-bold text-gray-800 text-lg flex items-center gap-2 min-w-0">
      <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center text-white text-sm shrink-0">
        🎵
      </div>

      <span className="truncate">
        Practice Mode
      </span>
    </h2>

    <button
      onClick={() => setSidebarCollapsed(true)}
      aria-label="Collapse sidebar"
      className="
        shrink-0
        h-12 w-12 rounded-2xl
        bg-gradient-to-br from-blue-600 to-indigo-600
        text-white
        shadow-lg shadow-blue-500/25
        hover:shadow-xl
        hover:scale-105
        active:scale-95
        transition-all duration-300
        flex items-center justify-center
      "
    >
      <BsArrowsCollapse className="text-2xl rotate-90" />
    </button>
  </div>

  <div className="w-full min-w-0 mb-4">
    <PresentationModeToggle
      presentationMode={viewMode === "presentation"}
      setPresentationMode={(next) =>
        setViewMode(next ? "presentation" : "practice")
      }
    />
  </div>

  <div className="space-y-3">
    {[
      {
        key: "echoing",
        label: "Echo Mode",
        icon: "🔄",
        desc: "Listen → Repeat",
        color: "from-blue-500 to-indigo-500",
      },
      {
        key: "shadowing",
        label: "Shadow Mode",
        icon: "🎭",
        desc: "Speak with narrator",
        color: "from-amber-500 to-orange-500",
      },
      {
        key: "manual",
        label: "Manual Mode",
        icon: "🎮",
        desc: "Manual control",
        color: "from-green-500 to-emerald-500",
      },
    ].map(({ key, label, icon, desc, color }) => (
      <button
        key={key}
        onClick={() => {
          cancelAllProcesses();
          setPracticeMode(key);
          setPreservedMode(key);
        }}
        className={`w-full text-left py-3 px-4 rounded-xl transition-all duration-300 font-medium text-sm flex items-center justify-between group border ${
          practiceMode === key
            ? `bg-gradient-to-r ${color} text-white shadow-lg border-transparent`
            : "bg-white/60 text-gray-600 hover:bg-white/80 border border-white/40 hover:border-white/60 hover:shadow-md"
        } ${
          (echoingPhase !== "idle" || recordingStatus === "recording") &&
          practiceMode !== key
            ? "opacity-50 cursor-not-allowed"
            : ""
        }`}
        disabled={
          (echoingPhase !== "idle" || recordingStatus === "recording") &&
          practiceMode !== key
        }
      >
        <div className="flex items-center gap-3">
          <div
            className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm ${
              practiceMode === key
                ? "bg-white/20"
                : "bg-gray-100 group-hover:bg-gray-200"
            }`}
          >
            {icon}
          </div>

          <div className="text-left">
            <div className="font-medium">{label}</div>
            <div
              className={`text-xs ${
                practiceMode === key
                  ? "text-white/80"
                  : "text-gray-500"
              }`}
            >
              {desc}
            </div>
          </div>
        </div>

        {practiceMode === key && (
          <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
        )}
      </button>
    ))}
  </div>

</div>

      {/* Visualization Controls - Desktop */}
      <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-gray-800 flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white text-sm">
              📊
            </div>
            Visualization
          </h3>

          <button
            onClick={() =>
              setShowIntonationVisualization(!showIntonationVisualization)
            }
            className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${
              showIntonationVisualization
                ? "bg-gradient-to-r from-blue-500 to-indigo-500 shadow-md"
                : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-all duration-300 ${
                showIntonationVisualization ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>
        </div>

        {showIntonationVisualization && (
          <div className="space-y-3">
            {[
              {
                key: "pitch",
                icon: "📈",
                label: "Pitch",
                color: "from-blue-500 to-cyan-500",
              },
              {
                key: "intensity",
                icon: "🔊",
                label: "Intensity",
                color: "from-orange-500 to-red-500",
              },
              {
                key: "music",
                icon: "🎵",
                label: "Music Notes",
                color: "from-purple-500 to-pink-500",
              },
              {
                key: "colors",
                icon: "🎨",
                label: "Color Words",
                color: "from-green-500 to-emerald-500",
              },
              {
                key: "combined",
                icon: "🌀",
                label: "Combined",
                color: "from-indigo-500 to-purple-500",
              },
            ].map(({ key, icon, label, color }) => (
              <button
                key={key}
                onClick={() => setVisualizationView(key)}
                className={`w-full p-4 rounded-xl transition-all duration-300 flex items-center gap-3 border ${
                  visualizationView === key
                    ? `bg-gradient-to-r ${color} text-white shadow-lg border-transparent`
                    : "bg-white/60 text-gray-600 hover:bg-white/80 border-white/40 hover:border-white/60 hover:shadow-md"
                }`}
              >
                <span className="text-lg">{icon}</span>
                <span className="font-medium text-sm">{label}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="h-24 shrink-0" />
    </>
  )}
</div>
            {/* Main Content Panel */}
<div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-y-auto bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">                  {/* Mobile Header */}
            <MobileHeader 
            language={subject?.language}
  mobileMenuOpen={mobileMenuOpen}
  setMobileMenuOpen={setMobileMenuOpen}
  setShowKeyboardHelp={setShowKeyboardHelp}
  showIntonationVisualization={showIntonationVisualization}
  setShowIntonationVisualization={setShowIntonationVisualization}
  visualizationView={visualizationView}
  setVisualizationView={setVisualizationView}
  practiceMode={practiceMode}
  setPracticeMode={setPracticeMode}
  cancelAllProcesses={cancelAllProcesses}
  setPreservedMode={setPreservedMode}
 isPublic={isPublic}
  todaySeconds={todaySeconds}
  goalSeconds={goalSeconds}
  setShowProgressModal={setShowProgressModal}
/>               
                {/* Keyboard Help Floating Button - Desktop */}
                {!isMobile && (
  <div className="fixed bottom-6 right-6 z-30">
                    <button
                        onClick={() => setShowKeyboardHelp(true)}
                        className="keyboard-help-button group p-3 bg-white/80 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg shadow-blue-500/5 hover:bg-white transition-all duration-300"
                        title="Keyboard Shortcuts (Press ?)"
                    >
                        <MdKeyboard className="text-gray-600 group-hover:text-blue-600 text-xl transition-colors" />
                    </button>
                </div>) }

                {/* Content Area */}
       {viewMode === "presentation" ? (
 <PresentationModeView
  audioref={audioref}
  fullaudio={fullaudio}
  timeUpdate={timeUpdate}
  segment={segment}
  segments={segments}
  handlePreviousSegment={handlePreviousSegment}
  handleNextSegment={handleNextSegment}
  isgranted={isgranted}
  getMicrophonePermission={getMicrophonePermission}
  practiceMode={practiceMode}
  recordingStatus={recordingStatus}
  isPlayingSegment={isPlayingSegment}
  recordingProgress={recordingProgress}
  handlePlayPause={handlePlayPause}
  handleMainAction={handleMainAction}
  getButtonConfig={getButtonConfig}
  rate={rate}
  setRate={setRate}
  loading={loading}
  assessment={assessment}
  subject={subject}
  file={file}
  handleLaneWordClick={handleLaneWordClick}
  broadcastTime={broadcastTime}
  visualizationView={visualizationView}
  auth={auth}
  resolvedAssessmentAudioUrl={resolvedAssessmentAudioUrl}
  resolvedNarratorAssessmentAudioUrl={resolvedNarratorAssessmentAudioUrl}
  canUsePronunciationApi={canUsePronunciationApi}
   echoingPhase={echoingPhase}
  isCueActive={isCueActive}
/>
) : (
  <PracticeModeView
  audioref={audioref}
  fullaudio={fullaudio}
  chapterTitle={sectionTitle}
  timeUpdate={timeUpdate}

  segments={segments}
  modelSize={modelSize}

  segment={segment}
  renderHelpPill={renderHelpPill}
  renderCommentsPill={renderCommentsPill}
  isMetadataNoHelp={isMetadataNoHelp}
  setShowExerciseHelp={setShowExerciseHelp}
  handlePreviousSegment={handlePreviousSegment}
  handleNextSegment={handleNextSegment}
  showCenterCue={showCenterCue}
  practiceMode={practiceMode}
  echoingPhase={echoingPhase}
  isCueActive={isCueActive}
  recordingStatus={recordingStatus}
  cuePulseCount={cuePulseCount}
  echoingPulseCount={echoingPulseCount}
  sentenceLabel={sentenceLabel}
  currentWord={currentWord}
  handleWordPlay={handleWordPlay}
  handleRangePlay={handleRangePlay}
  openWordMenu={openWordMenu}

  isgranted={isgranted}
  getMicrophonePermission={getMicrophonePermission}
  isPlayingSegment={isPlayingSegment}
  recordingProgress={recordingProgress}
  handlePlayPause={handlePlayPause}
  handleMainAction={handleMainAction}
  getButtonConfig={getButtonConfig}
  rate={rate}
  setRate={setRate}

  loading={loading}
  assessment={assessment}
  userRecordingUrl={audio}


  showIntonationVisualization={showIntonationVisualization}
  showIntonationHelp={showIntonationHelp}
  setShowIntonationHelp={setShowIntonationHelp}
  subject={subject}
  file={file}
  handleLaneWordClick={handleLaneWordClick}
  broadcastTime={broadcastTime}
  visualizationView={visualizationView}
  auth={auth}
  resolvedAssessmentAudioUrl={resolvedAssessmentAudioUrl}
  resolvedNarratorAssessmentAudioUrl={resolvedNarratorAssessmentAudioUrl}

  canUsePronunciationApi={canUsePronunciationApi}
  
  
/>
)}

                 <div className="h-24 xl:h-32 shrink-0" />
            </div>

            {/* Mobile Translation Modal */}
            {showTranslationModal && translation && (
                <div className="fixed inset-0 z-50 xl:hidden">
                    {/* Backdrop */}
                    <div 
                        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                        onClick={() => setShowTranslationModal(false)}
                    />
                    
                    {/* Modal Content */}
                    <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm rounded-t-3xl border-t border-white/30 shadow-2xl max-h-[85vh] overflow-hidden animate-in slide-in-from-bottom-1 duration-300">
                        <div className="p-6 max-h-[85vh] overflow-y-auto">
                            {/* Header */}
                            <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
                                <h2 className="font-bold text-gray-800 text-xl flex items-center gap-3">
                                    <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center text-white">
                                        🌐
                                    </div>
                                    Translation
                                </h2>
                                <button
                                    onClick={() => setShowTranslationModal(false)}
                                    className="p-2 hover:bg-gray-100 rounded-xl transition-all duration-200"
                                >
                                    <span className="text-gray-500 text-2xl">×</span>
                                </button>
                            </div>

                            {/* Translation Content */}
                            <div className="space-y-4">
                                {translation.translation[0]?.hasOwnProperty("normalizedSource") ? (
                                    <div className='space-y-4'>
                                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-200/50">
                                            <p className='font-semibold text-gray-800 text-lg'>
                                                {translation.translation[0].normalizedSource} 
                                            </p>
                                            <p className='text-xs text-gray-500 mt-1'>Normalized form</p>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                                <span className="text-amber-500">📖</span>
                                                Translations
                                            </h4>
                                            <ul className='space-y-3'>
                                                {translation.translation[0].translations.map((item, i) => (
                                                    <li key={i} className='flex items-start gap-3 p-3 rounded-xl bg-white/50 border border-gray-200'>
                                                        <span className='font-bold text-blue-500 bg-blue-100 rounded-lg px-2 py-1 text-xs flex-shrink-0'>{i+1}</span>
                                                        <span className="text-gray-700 flex-1">{item.displayTarget}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                ) : (translation.translation === "missing translation") ? (
                                    <div className="text-center py-8 bg-white/50 rounded-xl border border-gray-200">
                                        <div className="text-4xl mb-3 opacity-50">🔍</div>
                                        <p className="text-gray-600 font-medium">Translation not available</p>
                                        <p className="text-gray-500 text-sm mt-1">Try a different word</p>
                                    </div>
                                ) : (
                                    <div className="space-y-4">
                                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200/50">
                                            <p className='font-semibold text-gray-800 text-lg'>
                                                {translation.word}
                                            </p>
                                            <p className='text-xs text-gray-500 mt-1'>Word to translate</p>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                                <span className="text-green-500">📚</span>
                                                Translations
                                            </h4>
                                            <ul className='space-y-3'>
                                                {translation.translation[0].translations.map((item, i) => (
                                                    <li key={i} className='flex items-start gap-3 p-3 rounded-xl bg-white/50 border border-gray-200'>
                                                        <span className='font-bold text-green-500 bg-green-100 rounded-lg px-2 py-1 text-xs flex-shrink-0'>{i+1}</span>
                                                        <span className="text-gray-700 flex-1">{item.text}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Close Button */}
                            <div className="mt-8 pt-4 border-t border-gray-200">
                                <button
                                    onClick={() => setShowTranslationModal(false)}
                                    className="w-full py-3 px-4 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-xl font-medium transition-all duration-300 hover:shadow-lg"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                     
                </div>
              

            )}


            <WordActionMenu
  wordMenu={wordMenu}
  closeWordMenu={closeWordMenu}
  handleWordPlay={handleWordPlay}
  handleWordClick={handleWordClick}
  segment={segment}
/>

           {!isPublic && (
 <ProgressModal
  open={showProgressModal}
  onClose={() => setShowProgressModal(false)}
  doneSeconds={todaySeconds}
  goalSeconds={goalSeconds}
  minGoalSeconds={MIN_GOAL_SECONDS}   
  onGoalMinus={() => updateDailyGoal(goalSeconds - STEP_SECONDS)} // optional: simpler
  onGoalPlus={() => updateDailyGoal(goalSeconds + STEP_SECONDS)}
/>

)}
{helpMode === "context" ? (
  <ContextHelpModal
    open={showExerciseHelp}
    onClose={() => setShowExerciseHelp(false)}
    course={course}
    contextItem={currentContextItem}
    initialTab="overview"
  />
) : (
  <ExerciseHelpModal
    open={showExerciseHelp}
    onClose={() => setShowExerciseHelp(false)}
    exercise={hasExerciseHelp ? currentExercise : null}
    course={course}
    mode={hasExerciseHelp ? "exercise" : "about"}
  />
)}
<ChapterCommentsPanel
  open={showComments}
  onClose={() => setShowComments(false)}
  subject={subject}
  file={file}
  segment={segment}
  auth={auth}
  onCountsChange={setCommentCounts}
  chapterTitle={sectionTitle}
/>


        </div>
    );
    
};

export default SnapsWise;